import React from 'react';
import $ from '../../common/AjaxRequest';
import { Button, DatePicker, Select } from 'antd';
import SideNav from './SideNav';
import API_URL from '../../common/url';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';
import ExportUtil from '../../common/ExportUtil';
import moment from 'moment';

const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';

class GroupingRateCompare extends React.Component {
    state = {
        datas: [],
        searchParams: {},
    }

    componentDidMount() {
        this.setState({
            searchParams: {
                startDay: moment().format(dateFormat),
                statisticalMethod: 'WEEK',
            },
        }, () => {
            this.loadData();
        });
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'label',
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
              const { searchParams } = this.state;
              let url = API_URL.summary.exportInvestigationSiteGroupSpeed;
              ExportUtil.export({ ...searchParams }, null, url);
            },
            text: '导出Excel'
        }
    }

    loadData = () => {
        const { searchParams, searchParams: { statisticalMethod } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.summary.queryInvestigationSiteGroupSpeed,
            data: { ...searchParams },
            dateType: 'json',
            doneResult: res => {
                const { data = {}, datas = [] } = res;
                const isWeek = statisticalMethod == 'WEEK';
                this.setState({
                    data,
                    isWeek,
                    datas: datas || [],
                });
            }
        }
        $.sendRequest(options);
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    handleDateChange = (date, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    getChartConfig = () => {
        const { data, datas, isWeek } = this.state;
        let list = [];
        let splineName;
        let columnName;
        let splineList = [];
        let columnList = [];
        datas.forEach(item => {
            list.push(item.investigationSiteCode);
            columnList.push(isWeek ? item.weekGroupSpeed : item.monthGroupSpeed);
            splineList.push(isWeek ? data.weekGroupSpeed : data.monthGroupSpeed)
        });
        if (isWeek) {
            columnName = '中心入组周速率';
            splineName = '项目入组周速率';
        } else {
            columnName = '中心入组月速率';
            splineName = '项目入组月速率';
        } 
        return {
            title: {
                text: ''
            },
            chart: {
                type: 'line'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            yAxis: {
                title: {
                    text: ''
                },
            },
            xAxis: {
                categories: list,
            },
            series: [{
                type: 'column',
                name: columnName,
                data: columnList,
            }, {
                type: 'spline',
                name: splineName,
                data: splineList,
            }],
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            credits: {
                enabled: false,
            },
        };
    }

    render() {
        const { searchParams: { startDay, statisticalMethod } } = this.state;
        const newStartDay = startDay ? moment(startDay) : null;
        return (
            <div className="content primary-tabs-active">
                <SideNav selectKey='/summary/groupingRate' />
                <div className="main">
                    <div className="T-tit">
                        <div className="txt">
                            <h3 style={{ marginBottom: 10 }}>各中心入组速率对比</h3>
                        </div>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        日期：
                        <DatePicker
                            format={dateFormat}
                            allowClear={true}
                            placeholder="请选择"
                            value={newStartDay}
                            style={{ width: 120, verticalAlign: 'middle' }}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, 'startDay')}
                        />
                        <span className="ant-divider" style={{ margin: '0px 6px'}} />
                        统计方式：
                        <Select
                            value={statisticalMethod}
                            style={{width: 80, marginRight: 10}}
                            onChange={value => this.handleSelectChange(value, 'statisticalMethod')}
                        >
                            <Option value="WEEK">按周统计</Option>
                            <Option value="MONTH">按月统计</Option>
                        </Select>
                        <Button type='primary' style={{ marginLeft: 10 }} onClick={this.loadData}>统计</Button>
                    </div>
                    <div className="charts" style={{ marginBottom: 10 }}>
                        <Highcharts config={{ ...this.getChartConfig(), ...chartsConfig }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default GroupingRateCompare;


// WEBPACK FOOTER //
// ./src/components/summary/GroupingRateCompare.js